import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'baloo-edit-container',
    template: `
        <div class="fi-container">
            <div class="fi-header">
                <div class="fi-header-actions">
                    <fi-button-back-new></fi-button-back-new>
                </div>
                <div class="fi-header-text">
                    {{ 'baloo.baloo' | fiAppText }}
                </div>
                <fi-tabs
                    [tabsModel]="tabs"
                    [selectedIndex]="selectedIndex"
                    (selectedIndexChange)="onTabIndexChange($event)"
                >
                </fi-tabs>
            </div>
            <div class="fi-content ExtraLightBackgroundColor">
                <ui-view></ui-view>
            </div>
        </div>
    `,
    styleUrls: ['./baloo-edit-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'baloo-edit-container' },
    standalone: false,
})
export class BalooEditContainerComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.tabs.push({
            Title: this.appTextService.get('settings'),
            Sref: FiStateNames.OtherSettings.Baloo.Settings,
        });

        this.tabs.push({
            Title: this.appTextService.get('baloo.manual_sync'),
            Sref: FiStateNames.OtherSettings.Baloo.ManualSync,
        });

        this.tabs.push({
            Title: this.appTextService.get('baloo.sync_log'),
            Sref: FiStateNames.OtherSettings.Baloo.SyncLog,
        });

        this.tabs.push({
            Title: this.appTextService.get('common.match'),
            Sref: FiStateNames.OtherSettings.Baloo.Matching,
        });

        super.updateSelectedTabFromState();
    }
}
